import {
  CONFIRMED_GET_IMPLEADS,
  CONFIRMED_CREATE_IMPLEADS_ACTION,
  CONFIRMED_DELETE_IMPLEADS_ACTION,
  CONFIRMED_EDIT_IMPLEADS_ACTION,
} from "../actions/ImportLeadType";

const initialState = {
  importLeads: [],
  loading: false,
  num_rows: 0, 
  error: null,
};

export default function ImportLeadsReducer(state = initialState, action) {
  switch (action.type) {
    case CONFIRMED_GET_IMPLEADS:
      return {
        ...state,
        // importLeads: action.payload || [],
        importLeads: action.payload.importLeads || action.payload,
        num_rows: action.payload.num_rows || 0,
        loading: false,
        error: null,
      };

    case CONFIRMED_CREATE_IMPLEADS_ACTION:
      return {
        ...state,
        importLeads: [...state.importLeads, action.payload],
        loading: false,
        error: null,
      };

    case CONFIRMED_DELETE_IMPLEADS_ACTION:
      return {
        ...state,
        importLeads: state.importLeads.filter(
          (lead) =>
            lead.importLead_id !== action.payload.importLead_id &&
            lead.import_lead_id !== action.payload.importLead_id
        ),
        loading: false,
        error: null,
      };

    case CONFIRMED_EDIT_IMPLEADS_ACTION:
      return {
        ...state,
        importLeads: state.importLeads.map((lead) =>
          lead.importLead_id === action.payload.importLead_id ||
          lead.import_lead_id === action.payload.import_lead_id
            ? action.payload
            : lead
        ),
        loading: false,
        error: null,
      };

    default:
      return state;
  }
}
